import React from 'react';
export function GuaranteeSection() {
  return <div className="max-w-3xl mx-auto px-5 md:px-6 py-10" data-id="element-235">
      <hr className="border-t-2 border-dashed border-border-light mb-10" data-id="element-236" />

      <div className="bg-[#E8F5E9] border-2 border-green rounded-xl py-8 px-6 md:px-8 text-center my-8" data-id="element-237">
        <p className="text-5xl md:text-6xl mb-4" data-id="element-238">🛡️</p>

        <h2 className="font-serif text-2xl md:text-3xl font-bold text-green-dark mb-5" data-id="element-239">
          No Digas "Sí". Solo Di "Quizás" y Pruébalo SIN RIESGO.
        </h2>

        <p className="font-serif text-lg text-body-text mb-4 leading-relaxed" data-id="element-240">
          Odio ver la palabra "garantía" por todas partes. ¿Qué se supone que
          significa? Solo palabras vacías para que compres.
        </p>
        <p className="font-serif text-lg text-body-text mb-4 leading-relaxed" data-id="element-241">
          Así que no te hago una simple garantía. Te hago una{' '}
          <strong data-id="element-242">promesa personal</strong>.
        </p>
        <p className="font-serif text-lg text-body-text mb-6 leading-relaxed" data-id="element-243">
          Creo con total convicción que este es el paquete de estimulación
          temprana más completo que existe actualmente en español... Me tragaría
          la tierra si pensara que vas a quedar decepcionado/a. Así que aquí
          está el trato:
        </p>

        <p className="font-sans text-xl md:text-2xl font-bold text-green-dark my-6" data-id="element-244">
          Mi Garantía de 30 Días: "ÁMALO O DÉJALO"
          <br data-id="element-245" />
          100% Satisfacción Garantizada
        </p>

        <p className="font-serif text-lg text-body-text mb-4 leading-relaxed" data-id="element-246">
          Si este no es el recurso de estimulación temprana más completo que
          hayas visto, simplemente envíame un mensaje y te devolveré el{' '}
          <strong data-id="element-247">100% de tu dinero</strong>. Sin preguntas.
        </p>
        <p className="font-serif text-lg text-body-text leading-relaxed" data-id="element-248">
          Esta es mi garantía BLINDADA de devolución de dinero durante 30 días
          completos.
        </p>
      </div>
    </div>;
}